export const SAVE_FILE_TO_CDN = 'SAVE_FILE_TO_CDN';
export const SAVE_FILE_TO_CDN_COMMON = 'SAVE_FILE_TO_CDN_COMMON';
export const SAVE_POLICY_TO_CDN = 'SAVE_POLICY_TO_CDN';
export const DELETE_FILE_FROM_CDN = 'DELETE_FILE_FROM_CDN';
